import {
    MAENNLICHEN,
    EIGERGLETSCHER,
    KLEINESCHEIDEGG,
    FIRST,
    SCHRECKFELD,
    FAULHORN,
    BUSSALP,
    BIRG,
    ALLMENDHUBEL,
    WEBCAM_URLS,
} from '~/config/settings/settingsWeatherStations';

const mapPos = (pos) => 256 / 1600 * pos;

export const WEBCAM_MAENNLICHEN = {
    id: 'WEBCAM_MAENNLICHEN',
    x: mapPos(1215),
    y: mapPos(765),
    anchor: [0, 1],
    weatherStation: MAENNLICHEN,
    webcamURL: WEBCAM_URLS[MAENNLICHEN],
};

export const WEBCAM_EIGERGLETSCHER = {
    id: 'WEBCAM_EIGERGLETSCHER',
    x: mapPos(1030),
    y: mapPos(290),
    anchor: [0, 1],
    weatherStation: EIGERGLETSCHER,
    webcamURL: WEBCAM_URLS[EIGERGLETSCHER],
};

export const WEBCAM_KLEINESCHEIDEGG = {
    id: 'WEBCAM_KLEINESCHEIDEGG',
    x: mapPos(1150),
    y: mapPos(510),
    anchor: [0, 0],
    weatherStation: KLEINESCHEIDEGG,
    webcamURL: WEBCAM_URLS[KLEINESCHEIDEGG],
};

export const WEBCAM_SUMMER_MAENNLICHEN = {
    id: 'WEBCAM_SUMMER_MAENNLICHEN',
    x: mapPos(1005),
    y: mapPos(720),
    anchor: [0, 1],
    weatherStation: MAENNLICHEN,
    webcamURL: WEBCAM_URLS[MAENNLICHEN],
};

export const WEBCAM_SUMMER_EIGERGLETSCHER = {
    id: 'WEBCAM_SUMMER_EIGERGLETSCHER',
    x: mapPos(1050),
    y: mapPos(425),
    anchor: [0, 1],
    weatherStation: EIGERGLETSCHER,
    webcamURL: WEBCAM_URLS[EIGERGLETSCHER],
};

export const WEBCAM_SUMMER_KLEINESCHEIDEGG = {
    id: 'WEBCAM_SUMMER_KLEINESCHEIDEGG',
    x: mapPos(935),
    y: mapPos(565),
    anchor: [1, 0],
    weatherStation: KLEINESCHEIDEGG,
    webcamURL: WEBCAM_URLS[KLEINESCHEIDEGG],
};

export const WEBCAM_FIRST = {
    id: 'WEBCAM_FIRST',
    x: mapPos(705),
    y: mapPos(355),
    anchor: [0.5, 0],
    weatherStation: FIRST,
    webcamURL: WEBCAM_URLS[FIRST],
};

export const WEBCAM_SCHRECKFELD = {
    id: 'WEBCAM_SCHRECKFELD',
    x: mapPos(917),
    y: mapPos(432),
    anchor: [0, 0],
    weatherStation: SCHRECKFELD,
    webcamURL: WEBCAM_URLS[SCHRECKFELD],
};

export const WEBCAM_FAULHORN = {
    id: 'WEBCAM_FAULHORN',
    x: mapPos(270),
    y: mapPos(190),
    anchor: [0, 0],
    weatherStation: FAULHORN,
    webcamURL: WEBCAM_URLS[FAULHORN],
};

export const WEBCAM_BUSSALP = {
    id: 'WEBCAM_BUSSALP',
    x: mapPos(90),
    y: mapPos(375),
    anchor: [0.5, 0],
    weatherStation: BUSSALP,
    webcamURL: WEBCAM_URLS[BUSSALP],
};

export const WEBCAM_BIRG = {
    id: 'WEBCAM_BIRG',
    x: mapPos(660),
    y: mapPos(260),
    anchor: [1, 0.5],
    weatherStation: BIRG,
    webcamURL: WEBCAM_URLS[BIRG],
};

export const WEBCAM_ALLMENDHUBEL = {
    id: 'WEBCAM_ALLMENDHUBEL',
    x: mapPos(660),
    y: mapPos(470),
    anchor: [0, 1],
    weatherStation: ALLMENDHUBEL,
    webcamURL: WEBCAM_URLS[ALLMENDHUBEL],
};
